<template>
    <div class="medal">
        <img :src="imgUrl">
    </div>
</template>

<script>
    import Medal1 from '../assets/images/medal-01.png'
    import Medal2 from '../assets/images/medal-02.png'
    import Medal3 from '../assets/images/medal-03.png'
    import Medal4 from '../assets/images/medal-04.png'
    import Medal5 from '../assets/images/medal-05.png'

    export default {
        props: {
            value: null
        },
        data: function () {
            return {
                imgUrl: Medal1
            }
        },
        created () {
            switch (this.value) {
                case 1:
                    this.imgUrl = Medal5
                    break
                case 2:
                    this.imgUrl = Medal4
                    break
                case 3:
                    this.imgUrl = Medal3
                    break
                case 4:
                    this.imgUrl = Medal2
                    break
                case 5:
                    this.imgUrl = Medal1
                    break
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .medal {
        img {
            width: 82px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Medal.vue